// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TerminalList_wrapper__hfLPy"};